import { PollOption } from "@infrastructure/Services/PostService.types";
import { PostPollTextSection } from "./PostPollTextSection";
import { PostPollRateSection } from "./Rate/PostPollRateSection";
import { PostPollQuizSection } from "./Quiz/PostPollQuizSection";
import { PollTypesEnum } from "@shared/Types/Polls";
import { PostPollImageSection } from "./Image/PostPollImageSection";
import { PollType, PostIdType } from "../../Post.types";

export type BasePollType = {
    pollClosedAt: string | undefined;
    pollOptionHandler: (
        pollOptionId: number,
        type: "create" | "delete",
    ) => Promise<void>;
    pollOptions: PollOption[];
    postId: PostIdType;
};

type PostPollFactoryInput = {
    pollData: PollType;
    pollOptionHandler: BasePollType["pollOptionHandler"];
    postId: BasePollType["postId"];
    typeSpecificOpts?: {
        [PollTypesEnum.POLL_IMAGES]: { showSupportingText: boolean };
    };
    content?: string;
};

export function PostPollFactory({
    pollData,
    pollOptionHandler,
    postId,
    typeSpecificOpts,
    content,
}: PostPollFactoryInput) {
    const { type, closedAt, pollOptions } = pollData;
    switch (type) {
        case PollTypesEnum.POLL_VISIBLE:
            return (
                <PostPollTextSection
                    postId={postId}
                    pollClosedAt={closedAt}
                    pollOptionHandler={pollOptionHandler}
                    pollOptions={pollOptions}
                    showDetailsBeforeUserVote={true}
                    allowChangeAnswer={true}
                />
            );
        case PollTypesEnum.POLL_HIDDEN:
            return (
                <PostPollTextSection
                    postId={postId}
                    pollClosedAt={closedAt}
                    pollOptionHandler={pollOptionHandler}
                    pollOptions={pollOptions}
                    showDetailsBeforeUserVote={false}
                    allowChangeAnswer={false}
                />
            );
        case PollTypesEnum.POLL_IMAGES:
            return (
                <PostPollImageSection
                    postId={postId}
                    pollClosedAt={closedAt}
                    pollOptionHandler={pollOptionHandler}
                    pollOptions={pollOptions}
                    allowChangeAnswer={false}
                    showSupportingText={
                        typeSpecificOpts
                            ? typeSpecificOpts[PollTypesEnum.POLL_IMAGES]
                                  .showSupportingText
                            : true
                    }
                />
            );
        case PollTypesEnum.POLL_QUIZ:
            return (
                <PostPollQuizSection
                    postId={postId}
                    pollClosedAt={closedAt}
                    pollOptionHandler={pollOptionHandler}
                    pollOptions={pollOptions}
                    answerId={pollData.quizAnswerOptionId}
                />
            );
        case PollTypesEnum.POLL_RATING:
            return (
                <PostPollRateSection
                    postId={postId}
                    pollClosedAt={closedAt}
                    pollOptionHandler={pollOptionHandler}
                    pollOptions={pollOptions}
                    content={content}
                />
            );
        case PollTypesEnum.POLL_OFF:
        default:
            return null;
    }
}
